import { Injectable } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { LearningObjectiveInfoStateModel } from "../store/learning-objective-info.state";

// Model
export enum CitoApplicationModule {
  Rekenen,
  Spelling,
}

export enum UserType {
  candidate = 1,
  teacher = 2,
  coordinator = 3,
  system = 4,
}

export enum SessionState {
  notStarted = 1,
  started = 2,
  failed = 3,
  passed = 4,
  removed = 5,
}

export enum TestSessionStatus {
  NotStarted,
  Started,
  Failed,
  Passed,
}

export enum AssignmentStatus {
  AwaitingUpdate = 0,
  Unassigned, // planning
  Assigned, // planning
  TestStarted, // player
  Failed, // assessment result
  Passed, // assessment result
  PassedManually, // handmatig
  FailedManually, // handmatig
  OfflineReady, // player
}

export enum AssessmentResultStatus {
  Failed, // assessment result
  Passed, // assessment result
}
export class UserAction {
  isTeacher: boolean;
  action: string;
  trucatedPayload: string;
}
export class ObjectBase {
  id: string;
}
export class Group extends ObjectBase {
  name: any;
  selected?: boolean;
}

export class domainLoCollection {
  [key: string]: string[];
}

export class UserGroup {
  groupId: string;
  groupName: string;
}

export class Candidate {
  checked: boolean;
  groupId: string;
  firstname: string;
  lastname: string;
  preposition: string;
  inserts: string;
  name: string;
  email: string;
  picture: string;
  id: string;
  yearGroup: any;
  groupList: any;
  groupName: any;
  learningRoutesList: string[];
  learningRoutesSpellingList: string[];
}

export class Domain extends ObjectBase {
  title: string;
  subjects: Subject[];
}
export class CandidateProgress {
  groupId: string;
  candidateName: string;
  candidatePicture: string;
  candidateId: string;
  emoji: string;
  domainCandidateProgress: DomainCandidateProgress[];
  lastFiveLearningObjectivesDone: LearningObjectiveCandidateProgress[];
}

export class DomainCandidateProgress {
  domainId: string;
  domainTitle: string;
  // title: string;
  numberOfLearningObjectives: number;
  numberOfLearningObjectivesPassed: number;
}

export class Setting {
  key: string;
  value: string;
}
export class User {
  checked: boolean;
  schoolId: string;
  birthDate: string;
  groupId: string;
  isCitoEmployee: boolean;
  userType: number;
  firstname: string;
  lastname: string;
  preposition: string;
  inserts: string;
  name: string;
  emoji: string;
  leaver: boolean;
  username?: any;
  password?: any;
  email: string;
  idToken: string;
  id: string;
  picture: string;
  settings: Setting[];
  yearGroup: number;
  groupList: any;
  groupName: any;
  hasSeenLatestReleaseNotes: boolean;
  onboardingDisabled: boolean;
  learningRoutesList: string[];
  learningRoutesSpellingList: string[];
  appropriatePerspectivesList: string[];
}

@Injectable()
export class LearningObjective extends ObjectBase {
  citoId: string;
  childLanguageAudio: string;
  domainId: string;
  domainTitle: string;
  subjectCode: string;
  title: string;
  titleCandidate: string;
  parentLearningObjectiveId: string;
  code: string;
  offlineTest: boolean;
  gradeLevel: number;
  description: string;
  hasLaatEensZienClip: boolean;
  laatEensZienClipPath: string;
  laatEensZienClipName: string;
  tagList: string[];
  image: string;
  learningroutes: string[];
}

export class SelectedLearningObjective {
  ref: LearningObjective;
}

export class LearningObjectiveOrder extends ObjectBase {
  schoolId: string;
  groupId: string;
  title: string;
  isTemplate: boolean;
  learningObjectives: string[];
}

export class LearningObjectiveOrderVM {
  id: string;
  title: string;
  isTemplate: boolean;
}

export class Stats {
  assignedCount: number;
  failCount: number;
  passCount: number;
  unassignedCount: number;
}

export class LearningObjectiveAssignInfo extends LearningObjective {
  stats: Stats;
}
export class LearningObjectiveVM extends LearningObjective {
  inList: boolean;
}
export class Instruction {
  mp4Source: SafeUrl;
  webmSource: SafeUrl;
}
export class candidateVM extends Candidate {
  inList: boolean;
}
export class LearningObjectiveCandidateProgress {
  assignmentStatus: AssignmentStatus;
  lastModified: Date;
  formattedDate: string;
  learningObjectiveId: string;
  learningObjectiveTitle: string;
  gradeLevel: number;
  domainTitle: string;
}

export class LearningObjectiveCandidateProgressVM {
  assignmentStatus: AssignmentStatus;
  lastModified: Date;
  formattedDate: string;
  learningObjective: LearningObjective;
}

export class Assignment extends ObjectBase {
  domainId: string;
  domainTitle: string;
  groupId: string;
  candidateId: string;
  candidateLeft: boolean;
  learningObjectiveId: string;
  learningObjectiveTitle: string;
  learningObjectiveTitleCandidate: string;
  latestTestSessionId: string;
  status: AssignmentStatus;
  id: string;
  isOffline: boolean;
}
export class AssessmentResultCandidate {
  id: string;
  firstname: string;
  lastname: string;
  name: string;
  picture: string;
}

export class AssessmentItemResult {
  itemId: string;
  response: string;
  rawScore: number;
  correctAnswer: string;
  itemFeedbacks: Array<ItemFeedback>;
}

export class ItemFeedback {
  foutType: string;
  text: string;
}

export class AssessmentResult {
  id: string;
  assessmentId: string;
  domainTitle: string;
  learningObjectiveId: string;
  learningObjectiveTitle: string;
  qtiPlayerSessionId: string;
  status: TestSessionStatus;
  items: AssessmentItemResult[];
  candidate: AssessmentResultCandidate;
  isOffline: boolean;
  lastModified: Date;
  assignmentStatus: AssignmentStatus;
}
export class DataAssignment {
  candidateId: string;
  learningObjective: LearningObjective;
  status: AssignmentStatus;
}

export class FormattedAssignmentLogEvent {
  message: string;
  testSessionId: string;
  assignmentAction: AssignmentStatus;
}
export class AssignmentLogEvent extends ObjectBase {
  assignmentId: string;
  actorId: string;
  actorName: string;
  assignmentAction: AssignmentStatus;
  targetId: string;
  targetName: string;
  testSessionId: string;
  timestamp: Date;
}

export class AssignmentStatusStateModel {
  assignment: Assignment;
  buttons: StatusButton[];
}

export class StatusButton {
  status: AssignmentStatus;
  disabled: boolean;
  flex: number;
}

export enum PassFail {
  NOT_SET = 1,
  PASS = 2,
  FAIL = 3,
}

export class PlanningElementClickedCommand {
  candidateId: string;
  learningObjectiveId: string;
  left: number;
  top: number;
}

export enum ReferenceLevelFilter {
  NO_FILTER = 0,
  _1S = "1S",
  _1F = "1F",
  _2F = "2F",
  _3F = "3F",
}

export enum LearningRouteFilter {
  NO_FILTER = 0,
  L1 = "L1",
  L2 = "L2",
  L3 = "L3",
}

export enum DomainFilter {
  NO_FILTER = 0,
  GETALLEN = 1,
  METEN_MEETKUNDE = 2,
  VERHOUDINGEN = 3,
  VERBANDEN = 4,
}

export enum DomainFilterSpelling {
  NO_FILTER = 0,
  WEETWOORDEN = 1,
  WERKWOORDEN = 2,
  REGELWOORDEN = 3,
  KLANKWOORDEN = 4,
}

export enum GradeLevelFilter {
  NO_FILTER = 0,
  GROEP1 = 1,
  GROEP2 = 2,
  GROEP3 = 3,
  GROEP4 = 4,
  GROEP5 = 5,
  GROEP6 = 6,
  GROEP7 = 7,
  GROEP8 = 8,
}

export enum TagFilter {
  NO_FILTER = 0,
  M3 = 5,
  E3 = 6,
  M4 = 7,
  E4 = 8,
  M5 = 9,
  E5 = 10,
  M6 = 11,
  E6 = 12,
  M7 = 13,
  E7 = 14,
  B8 = 15,
  M8 = 16,
}

export enum YearGroupFilter {
  NO_FILTER = 0,
  GROEP1 = 1,
  GROEP2 = 2,
  GROEP3 = 3,
  GROEP4 = 4,
  GROEP5 = 5,
  GROEP6 = 6,
  GROEP7 = 7,
  GROEP8 = 8,
}

export interface ProfileData {
  learningRoutes: string[];
  learningRoutesSpelling: string[];
}

export interface LearningObjectiveInfoWithVideoState
  extends LearningObjectiveInfoStateModel {
  videoMp4: SafeUrl;
  videoWebm: SafeUrl;
}

export interface Label {
  key: string;
  value: string;
}
export class Goal {
  code: string;
  title: string;
  labels: Label[];
  learningObjectives: LearningObjectiveInGoal[];
  in: string[];
  out: string[];
  aligned: string[];
}

export class LearningObjectiveInGoal extends LearningObjectiveVM {
  learningObjectives: LearningObjectiveVM[];
}

export interface Subject {
  code: string;
  title: string;
  goals: Goal[];
}

export class School extends ObjectBase {
  public casNumber: string;
  public name: string;
}
export class Auth0Settings {
  auth0ClientId: string;
  auth0TenantUrl: string;
}
